import React from 'react';
import DropsuiteN1LogoSvg from '@images/logos/dropsuite-n1-logo.svg';
import PropTypes from 'prop-types';

export default function QboLogo({ logo }) {
  return (
    <div className="QboLogo__wrapper">
      <img
        src={logo || DropsuiteN1LogoSvg}
        alt="dropsuite-n1-logo"
        className="Img__fluid QboLogo__main"
      />
    </div>
  );
}

QboLogo.propTypes = {
  logo: PropTypes.string,
};
QboLogo.defaultProps = {
  logo: null,
};
